import React from 'react';
import ReactDom from 'react-dom';
import {LexemePageContext} from "../../../LexemePageContext";
import Dict from 'dict-lib';
import {LexemePhrase} from "./LexemePhrase";
import {ModalPlayPhrases} from "./LexemeSenses";
import stylesLexemePhrases from './../../../../../_css/dictionary/lexemeParts/lexemePhrases.module.css';

export class LexemeGeneralPhrases extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalPlayShow: false
        };
    }

    render() {
        var phraseologies = [];
        var item = null;
        if(this.props.page.subentries.length > 0 && this.props.page.subentries[0].senses.length > 0) {
            phraseologies = this.props.page.subentries[0].senses[0].phraseologies;
            item = this.props.page.subentries[0].senses[0];
        }

        const itemDescription = '';


        return phraseologies !== null && phraseologies.length > 0 ? <div className={stylesLexemePhrases['lexeme-general-phraseology']}>
            <ModalPlayPhrases items={phraseologies}
                              show={this.state.modalPlayShow}
                              callbackParent={(newState) => {
                                  this.setState({modalPlayShow: newState})
                              }}
                              senseDescr={itemDescription}/>
            <div className={stylesLexemePhrases['lexeme-general-phrase__label']}>{Dict.t('GENERAL_PHASEOLOGY') + ":"}</div>
            <LexemePhrase key={"key-sense-phrases-general"} suItem={item} isSense={false} phraseAsGeneral={true}
                          isPolyFromLexeme={false}/>
        </div> : '';
    }

}

LexemeGeneralPhrases.contextType = LexemePageContext;